export enum ApplicationStatusType_Enum {
  Pending = 0,
  MoreInfo = 1,
  Dealt = 5,
  Proceeding = 44,
  Dead = 46,
  InitialContact = 47,
  UnableToContact = 48,
  Underwriting = 49,
  AwaitingDecision = 50,
  OnHold = 53,
  DocsOut = 56,
  Payout = 58,
  FurtherUnderwriting = 61,
  PrimeNotAllocated = 62,
  AwaitingPayout = 65,
  Duplicate = 66,
  AwaitingValCall = 67,
  CancelledDeal = 68,
  AcceptedNotAllocated = 69,
  DocsReceived = 70,
  MarketingTextYes = 71,
  MarketingTextLink = 72,
  MarketingEmailLink = 73,
  AmigoPaidOut = 74,
  GeorgeBancoPaidOut = 75,
  AmigoAwaitingAllocation = 76,
  ALPHAReview = 77,
  SuspectedFraud = 78,
  AmigoCustomerSigned = 79,
  AmigoGuarantorSigned = 80,
  MoreInfoPCP = 81,
  GloAwaitingAllocation = 82,
  PaymentProcessing = 83,
  AllocatedToTeam = 84,
  UnderwriterReview = 85,
  HoldForFutureProcessing = 86
}
